


<atomic-search-interface #searchInterface fields-to-include='["source","sourcename","contentdocumenttype","contentdocumentsubtype","contentdescription","qddocumenttype","qddocumentsubtype","contentproactive","contentsourceid","gmsavvmcapprovaldate","payerregion","mrlclassification","contentdocumentnumber","contentsourceid","gmsacountry","contentinclm","contentinirms","qdsensitivityclassification","impactedcountry","payer","payertopic","gmsaregion","contentproductname","vvmctherapeuticareaveap","vvmctherapeuticarea","contentintendeduse","contentlanguage","contentproactive","contentdocumentowner","contentspcategoryannouncements","contentspcategoryfunctionalareas","contentspcategorygmacapabilities","contentspcategoryleadermessages","contentspcategoryregions","contentspcategoryspecialtopics","contentspcategorytherapeuticareas","contenttherapeuticarea","contentspauthor","gmsapublisheddate","contentversion","qdimpacteddepartment","contentitemstatus","gmsaapprovaldate","qdeffectivedate","qdfinaldate","gvdsection","vvmcgvdeffectivedate","vvmcgvdindication","vvmcgvdveapid","productgenerictradename","vvmcgvdkeycontact","vvmcgvddepartment","contentversion","vvmc_core_model_type","vvmc_core_dcr_approval_date","vvmc_core_activity_type","contentapprovaldate","spouniqueid", "vvmcallowpdfdownload","qddocumentversionowner","relateddocuments","nisapprovaldate","niscompletiondate","nisactivitystatus","veap_obj_id","veapprojecttitle","veapmkvnumber","veapcustomerbusline","veaptherapeuticarea","veapisldg","veapcontact","veapactivitytype","veapindication","veapproduct","veapcountry","nisdocumenttype","endorsedyear","valueevidencedataandresearch","valueevidencesynthesisandcommunication","veapstudyobjective","veapdocsclassification","veap_obj_title","nisstudyprotocaldate","nisstudyreportdate","esatechnicalreportdate","nissummaryslidecompletiondate","vees_region","vees_category","vees_region","vees_therapyarea","vees_description","vees_company","vees_edition","vees_insights","vees_merck_disease_area","vees_source","vees_contact","vees_geographic_focus","submitter","description","region","therapeutic_area","event", "ideacode","submission_date","status","category","tags","category_gmsa_innovation_forum_award","poster_topics","business_priority_focus_theme", "idea_tags","gmsa_sub_therapeutic_area","title","resourcetype","franchise","contentproductname","classification","contentlanguage","gmsavvpmresourcetype","gmsavvpmresourcetype","gmsavvpmfranchise","steward","approvaldatedistribution","gmsavvpmclassification","contentdocid","vvpmcontentdocumenttype","vvpmcontentdocumentsubtype","vvpmcontentproductname","vvpmcontentlanguage","gmsavvpmcontentproductname","vvpmcountry","pie_therapeutic_area","pie_disease_type","pie_type_patient_engagement","pie_region","pie_clinicaltrial","pie_patientexperience","pie_access","pie_patientfeedback","pie_date","pie_author","stp_title","stp_description","mr_information_classification","mr_stage_model_development","mr_model_steward","mr_version_number","mr_therapeutic_area","mr_name_product","mr_disease","mr_model_type","mr_country", "mr_value_implementation_lead","mr_global","gmsa_vvmc_plan_year","stp_joint_publication","stp_strategic_areas_of_interest","stp_enhanced_capabilities","stp_country","stp_partnership_history","stp_type_of_data","stp_veap","stp_point_of_contact"]'>




  <app-results-page-header (mydrive)="myOneDriveClicked($event)" (mycollections)="myCollectionsClicked($event)"></app-results-page-header>

  <!-- <div style="position: absolute;top: 4rem;" (click)="loadDoc()">TRYING...</div> -->
  <div *ngIf="settingsPage"><app-usersettings></app-usersettings></div>
  <div *ngIf="resultsPage">
  <atomic-search-layout style="background-color: #EBEBEB;">
    <!-- <div class="header-bg" style="position: absolute;">
      <atomic-search-box></atomic-search-box>
    </div> -->

    
    
    <!-- <button (click)="SavedSearchMsg1()">TEST</button> -->

    <atomic-layout-section section="search" id="search-box" style="height: 6rem;">
      <!-- <atomic-search-box></atomic-search-box> -->
    </atomic-layout-section>

    <atomic-layout-section *ngIf="isRockyMountainUser ==  true" style="margin-top: -4rem; margin-bottom: 2rem;" section="facets">
      <!-- <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contenttherapeuticarea" label="Therapeutic Area"></atomic-facet> -->

      <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="vvmctherapeuticarea" label="Therapeutic Area (VVMC)"></atomic-facet>

      <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentproductname" label="Product"></atomic-facet>
      <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentcategory" label="Category"></atomic-facet>
    </atomic-layout-section>

    <atomic-layout-section *ngIf="isRockyMountainUser ==  false" style="margin-top: -4rem; margin-bottom: 2rem;" section="facets">
      
      <!-- <atomic-facet  is-collapsed="true" -manager> -->
        <!-- <atomic-category-facet
          field="geographicalhierarchy"
          label="World Atlas"
          with-search
        >
        </atomic-category-facet> -->
        <!-- <button (click)="selectAllExternalUseDocs()">External Use</button> -->
        <div style="margin-bottom: 0; display: flex; align-items: center;">
          <span style="font-family: invention; color: rgba(0, 0, 0, 0.88); font-size: 16px;font-weight: 600;padding-left: 10px; padding-right: 10px;">External Use</span><label class="switch" style="height: 38px; margin-bottom: 0;">
            <input [checked]="isExternalUseEnabledMain" type="checkbox" (change)="selectAllExternalUseDocs($event)">
            <span class="slider round"></span>
          </label>
        </div>
        
        <!-- <atomic-facet sort-criteria="alphanumeric"  is-collapsed="true"   is-collapsed="true" field="contentintendeduse" label="Intended Use" numberOfValues="6"></atomic-facet> -->
        <atomic-timeframe-facet is-collapsed="true"  facet-id="contentapprovaldate" field="contentapprovaldate" label="Date" with-date-picker>
          <!-- <atomic-timeframe
            unit="year"
            amount="10"
            period="next"
          ></atomic-timeframe> -->
        </atomic-timeframe-facet>
        <atomic-facet id="country-facet" facet-id="gmsacountry-common" sort-criteria="alphanumeric" is-collapsed="true"   field="gmsacountry" label="Country">{{changeLabelOfFacet('country-facet','Expand and select the Country')}}</atomic-facet>

        <div style="padding: 10px;
        /* border: 1px solid teal; */
        border-radius: 5px;
        box-shadow: 0 0 0 1px #cfd9e0;">
        <div style="font-weight: 700; font-size: 16px;">Asset Type</div>
        <div>
        <atomic-facet sort-criteria="alphanumeric"  is-collapsed="true"   field="csn_medical_affairs_asset_type" label="Medical Affairs" numberOfValues="6"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="csn_quality_documents_asset_type" label="Standards"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="csn_news_communications_asset_type" label="News and Communications" numberOfValues="6"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="valueevidencedataandresearch" label="Value Evidence Data and Research"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="csn_value_evidence_synthesis_communication_asset_type" label="Value Evidence Synthesis and Communication" numberOfValues="16"></atomic-facet>
        </div>
        </div>  
        <atomic-facet id="source" title="check" sort-criteria="alphanumeric" is-collapsed="true"   field="source" label="Source" numberOfValues="6"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric"  is-collapsed="true"   is-collapsed="true" field="contentintendeduse" label="Intended Use (VVMC)" numberOfValues="6"></atomic-facet>


        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentcountry" label="Region" numberOfValues="6"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contenttherapeuticarea" label="Therapeutic Area"></atomic-facet>

        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentspcategoryannouncements" label="Announcements"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentspcategoryfunctionalareas" label="Functional Areas"></atomic-facet>

        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentspcategorygmacapabilities" label="GMA Capabilities"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentspcategoryleadermessages" label="Leader Messages "></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentspcategoryspecialtopics" label="Special Topics "></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentspauthor" label="Author" numberOfValues="6"></atomic-facet>


        
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentdocumenttype" label="Document Type (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"  numberOfValues="5"  field="contentdocumentsubtype" label="Document SubType (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="vvmctherapeuticarea" label="Therapeutic Area (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="gmsa_sub_therapeutic_area" label="Sub Therapeutic Area (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentproductname" label="Product (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentcategory" label="Category (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contenttopic" label="Topic (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentlanguage" label="Language (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentinclm" label="Content In CRM (VVMC)"></atomic-facet>

        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="contentproactive" label="Proactive (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="payer" label="Payor Use Only (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="payerregion" label="Payor Region (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="payertopic" label="Payor Topic (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="vvmcgvdveapid" label="REV/OPS ID"></atomic-facet>


        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="qdcontentcountry" label="Country"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="qddocumenttype" label="Document Type (VVQD)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="qddocumentsubtype" label="Document SubType (VVQD)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="mrlclassification" label="MRL Classification (VVQD)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="impactedcountry" label="Impacted Countries/Regions (VVQD)"></atomic-facet>



        <!-- <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="nisdocumenttype" label="Documents"></atomic-facet> -->
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="veapdocsclassification" label="Classification (VVMC)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="veaptherapeuticarea" label="Therapeutic Area (REV/OPS)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="veapproduct" label="Name of Product (REV/OPS)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="veap_obj_title" label="REV/OPS ID"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="veapindication" label="Indication / Disease (REV/OPS)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="veapcountry" label="Country (REV/OPS)" delimiting-character=","></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="veapcontact" label="Steward / Contact (REV/OPS)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="veapactivitytype" label="Activity Type (REV/OPS)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="nisactivitystatus" label="Activity Status (REV/OPS)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="veapisldg" label="Is LDG? (REV/OPS)"></atomic-facet>

        <!-- Bright idea Facets -->
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="idea_status" label="Status"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="idea_category" label="Category"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="idea_tags" label="Tags"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="idea_event_initiative" label="Event / Initiative (Select all that apply)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="idea_region" label="Region"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="idea_category_gmsa_innovation_forum" label="Category - GMSA Innovation Forum Award"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="idea_poster_topics" label="Poster Topics - 2023 GMVC Summit"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="idea_therapeutic_area" label="Therapeutic Area(s)"></atomic-facet>
        <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="idea_business_priority" label="Business Priority / Focus / Theme"></atomic-facet>
        
          <!-- VEES Facets -->
          <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="vees_therapyarea" label="Therapeutic Area (VEES)"></atomic-facet>
          <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="vees_region" label="Region (VEES)"></atomic-facet>
          <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="vees_geographic_focus" label="Country (VEES)"></atomic-facet>
          <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="vees_contact" label="Steward/Contact (VEES)"></atomic-facet>
          <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="vees_category" label="Category (VEES)"></atomic-facet>
          <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="vees_company" label="Company (VEES)"></atomic-facet>
          <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="vees_merck_disease_area" label="Merck Disease Area (VEES)"></atomic-facet>
          
           <!--Promomats facets-->

           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="gmsavvpmresourcetype" label="Resource Type (VVPM)"></atomic-facet>
           <!-- <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="gmsacountry" label="Country (VVPM)"></atomic-facet> -->
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="gmsavvpmfranchise" label="Therapeutic Area (VVPM)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="vvpmcontentproductname" label="Product (VVPM)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="steward" label="Steward / Contact (VVPM)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="vvpmcountry" label="Country (VVPM)"></atomic-facet>



           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="pie_therapeutic_area" label="Therapeutic Area (PIE)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="pie_disease_type" label="Tumor or Disease (PIE)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="pie_type_patient_engagement" label="Type of Engagement (PIE)"></atomic-facet>
           <atomic-facet facet-id="steward-pie" sort-criteria="alphanumeric" is-collapsed="true"   field="pie_author" label="Steward (PIE)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="pie_region" label="Region (PIE)"></atomic-facet>
          

           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="mr_name_product" label="Name of Product (Models)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="mr_disease" label="Indication/Disease (Models)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="mr_country" label="Country (Models)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="mr_model_steward" label="Steward/Contact (Models)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="mr_stage_model_development" label="Stage of model development (Models)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="mr_model_type" label="Type of model (Models)"></atomic-facet>


           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="stp_veap" label="REV/OPS ID (Str Part)" delimiting-character=","></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="stp_country" label="Country (Str Part)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="stp_point_of_contact" label="Steward/Contact (Str Part)"></atomic-facet>
           <atomic-facet sort-criteria="alphanumeric" is-collapsed="true"   field="stp_type_of_data" label="Type of Data (Str Part)"></atomic-facet>


        
      <!-- </atomic-facet-manager> -->
    </atomic-layout-section>
    <atomic-layout-section section="main" class="main-section">

      <div  *ngIf="isRockyMountainUser == false" id="external-use">
        <!-- <div>
          External use of materials by Field Medical is governed by applicable SOPs and requires use of, and recording in, the designated system of record.
        </div>
        <div>
          Availability of content through this Navigator does not relieve users of compliance obligations.
        </div>   -->
        <!-- <span [innerHTML]="externalUse" style="display: block; white-space: pre-line;"></span> -->
        <span [innerHTML]="externalUse"></span>

      </div>

      <!-- <button style="padding: 0.5rem;
      border-radius: 1rem;
      background-color: #ffffff;
      color: teal;
      cursor: pointer;
      border: none;" type="button" (click)="clearAll()">Clear All</button> -->

<atomic-layout-section section="status" style="margin-top: -3rem;">
  <!-- <button (click)="freezeResults()">Freeze results</button> -->
  <atomic-query-summary></atomic-query-summary>
  <atomic-refine-toggle></atomic-refine-toggle>
  <atomic-breadbox></atomic-breadbox>
  <atomic-sort-dropdown style="font-family: Invention; font-size: 0.875rem;">
    <atomic-sort-expression label="relevance" expression="relevancy" [selected]="sortingMostRecentFlag  == false"></atomic-sort-expression>
    <atomic-sort-expression label="most-recent" expression="contentapprovaldate descending" [selected]="sortingMostRecentFlag == true"></atomic-sort-expression>
    <!-- Other sort expressions -->
</atomic-sort-dropdown>

  
</atomic-layout-section>

 <div *ngIf="loadingIndicater">
     Please wait while results are loading...
 </div> 

<div class="banner"  *ngIf = "myOneDriveflag"><div  class="banner-left" (click)="backToResultsFromMyOneDrive()"><span style="cursor: pointer;">Back to results</span></div><div  class="banner-center">My OneDrive</div></div>
   <app-csn-popup  *ngIf = "myOneDriveEmptyflag" (emptyDrivePopupEmit)="closeDriveEmptyPopup()" [title]="myDriveTitle" [body]="myDriveMessage" [feature]="feature"></app-csn-popup>  


<!-- <div  *ngIf = "myCollectionsflag" style="    width: 99%;
        padding: 15px 4px 15px;
        background: white;
        border-radius: 3px;
        border: 1px solid lightgrey;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 12px;
        font-family: invention;
        display: flex;"><div style="flex-basis: 45%; cursor: pointer;" (click)="backToResultsFromMyMyCollections()"><span style="border-radius: 12px;
    padding: 5px;
    text-decoration: underline;
    color: teal;
    font-weight: 400;">Back to results</span></div><div>{{collection.collection.name}}</div>
    </div> -->


    <div *ngIf="newnameFlag" style="color: black;">
      <app-collections [newnameFlag]="newnameFlag" [colObj] = "sharedCollection" [collectionName]="collection.name"></app-collections>
    </div>

    <!-- <div *ngIf="newnameFlag" style="color: black;"> -->
      <app-collections #collectionsCmp></app-collections>
    <!-- </div> -->

    <!-- <div *ngIf="newnameFlag" style="color: black;"> -->
      <!-- <app-collections [newnameFlag]="newnameFlag" [colObj] = "sharedCollection" [collectionName]="collection"></app-collections> -->
    <!-- </div> -->


    <div class="banner" id="bannerCollections"   *ngIf="myCollectionsflag">
        <div  class="banner-left"  (click)="backToResultsFromMyMyCollections()">
        <span style="cursor: pointer;">Back to results</span></div>
        <div [title]="collection.name"  class="banner-center" >
          {{ collection.name.length > 45 ? (collection.name | slice:0:25) + '...' : collection.name }}
          <!-- {{collection.name}} -->
        </div>
        <div *ngIf="collectionShareSaveBtn=='false'" style="margin-left:auto;">
          <button class="banner-right docFavSaveBtn" (click)="newnameFlag=true;customEventSaveCollections()">Save</button>
        </div>
        <div *ngIf="!collectionShareSaveBtn" style="display: flex; gap:15px;margin-left:auto;">
          <button class="banner-right docFavSaveBtn" (click)="renameCollection(collection);customEventRenameCollections(collection)">Rename</button>
          <button class="banner-right docFavSaveBtn" (click)="shareCollection(collection);customEventShareCollections(collection)">Share</button>
          <button class="banner-right docFavSaveBtn" (click)="deleteCollection(collection);customEventDeleteCollections(collection)">Delete</button>
        </div>
    </div>


      <app-csn-popup  *ngIf = "myCollectionsEmpty" [title]="myCollectionsTitle" [body]="myCollectionMessage" [feature]="feature" (emptyCollectionPopupEmit)="closeEmptyCollectionPopup()"></app-csn-popup>  


      <atomic-no-results>
        <div class="searchtips">
          <div>

            Sorry, we couldn't find any results.
            <div style="margin-top: 1rem;">Search tips:</div>
            <ul>
              <li>Check the spelling of your keywords.</li>
              <li>Try using fewer, different or more general keywords.</li>

              <li>Check if the country filter was automatically applied to your search.</li>
              <li>The document may be expired, withdrawn, or otherwise not in an approved state.</li>
              <li>Select fewer filters to broaden your search.</li>
            </ul>
          </div>
          <div>
          </div>
        </div>
      </atomic-no-results>

      

      
      <!-- <atomic-layout-section section="pagination">
        <div style="display: flex; justify-content: space-between; width: 100vw;">
          <div><atomic-pager></atomic-pager></div>
          <div><atomic-results-per-page></atomic-results-per-page></div>
        </div>
      </atomic-layout-section> -->

      <div *ngIf="SavedSearchAddPopupShowFlag"><app-savedsearch #savedSearch [SavedSearchTextMsg]="SavedSearchTextMsg" [SavedSearchAddPopupShow]="SavedSearchAddPopupShow" [message]="saveSearchPopupMesage" [title]="saveSearchPopupTitle" (patternNameAdded)="SaveSearchWithPattern($event)" (close)="closeSavedSearchPopup()"></app-savedsearch></div>
      
      <div *ngIf="SavedSearchMsg"><app-savedsearch #savedSearch *ngIf="SavedSearchMsg" [SavedSearchMsg]="SavedSearchMsg" [message]="saveSearchPopupMesage" [title]="saveSearchPopupTitle" (close)="closeSavedSearchPopup()"></app-savedsearch></div>

      <div *ngIf="export" >
        <app-export-to-excel [exportToExcelPopUp]="exportPopUp" (close)="closeExportPopup()"></app-export-to-excel>
     </div>
      <div   *ngIf="isRockyMountainUser == false"  class="floating-popup" style="display: flex; flex-direction: column; color: #00857c;">
        <!-- <div>
          <span style="    border: 1px solid teal;
          border-radius: 3px;" (click)="floatingPopup()" class="material-icons outlined">switch_right</span> 
        </div> -->

        <div>
          <div class="floating-popup-item" title="Save Search." style="display: flex; align-items: center;" (click)="saveSearch();customEventsSaveSearch()"><span> <span class="material-icons outlined sync-icon">star_outline</span></span></div>
        </div>
        <div>
          <div class="floating-popup-item" title="Export to Excel" style="display: flex; align-items: center;"  (click)="exportToExcel();" ><span><img (click)="floatingPopup()" height="25" class="sync-icon" src="./../../assets/merck-assets/exp.svg" style="margin-left: 5px; width:20px"></span></div>
        </div>

        <div style=" color: teal;">
        <!-- <div>
          <div class="floating-popup-item" style="display: flex; align-items: center;" *ngIf='floatingPopupFlag' (click)="saveSearch()"><span> <span class="material-icons outlined sync-icon">star_outline</span></span><span>Save Search</span></div>
        </div> -->
        <!-- <div>
          
          <div class="floating-popup-item" style="display: flex; align-items: center;" *ngIf='floatingPopupFlag' (click)="exportToExcel()" ><span><img (click)="floatingPopup()" height="25" class="sync-icon" src="./../../assets/merck-assets/exp.svg" style="margin-left: 5px; width:20px"></span><span>Export to Excel</span></div>
         </div> -->
         </div> 

        <!-- <div>Save Search</div> -->
        <!-- <div>Save Search</div> -->
      </div>

      <!-- <div  class="floating-popup1" style="position: fixed; right: 0;box-shadow: 0px 3px 6px 0px #000000;
      padding: 4px;
      background: #FFFFFF;">
      <div style="display: flex;">
      <img (click)="floatingPopup()" height="25" class="sync-icon" src="./../../assets/merck-assets/excel.jpg"/>
        <div *ngIf='floatingPopupFlag' (click)="exportToExcel()" style="    width: fit-content;
        padding: 5px 8px 5px 8px;
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        font-family: invention;
        cursor: pointer;">Export to Excel</div>
        </div>
      </div> -->
      

      <atomic-layout-section section="results">

        <!-- <app-result-list [resultCallback]="onResultClick"></app-result-list> -->
        
        
        <app-result-list #restList>
          
        </app-result-list>
 
        <!-- <atomic-quickview style="position: relative; top:5rem;"></atomic-quickview> -->

        <!-- <atomic-result-list id=${raw.contentdocumentnumber} (click)='handleClick()' display="list" image-size="icon" density="compact">
          <atomic-result-template>
            <template>

              <script>
                var ac1 = document.getElementById('clk').addEventListener("click", (event) => {
                  // console.log("called");
                });
                </script>

               <style>
                tomic-quickview{
                  width: 2 rem;
                }
               </style> 

              <atomic-quickview style="position: relative; top:5rem;"></atomic-quickview>
              <atomic-result-section-badges>
                <atomic-result-badge field="objecttype"></atomic-result-badge>
              </atomic-result-section-badges>
              <atomic-result-section-title>
                <atomic-result-link></atomic-result-link>
              </atomic-result-section-title>
              <atomic-result-section-visual>
                <atomic-result-icon></atomic-result-icon>
              </atomic-result-section-visual>

              <atomic-result-section-actions>
              </atomic-result-section-actions>
              <atomic-result-section-title-metadata>
                <div style="display: flex; justify-content: space-between;max-width: 80%;">
                  <div>
                    <div></div>
                    <atomic-field-condition style="display: flex;" part="source-field" class="field" if-defined="sourcename">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Source"></atomic-text> :  </span>
                      <atomic-result-multi-value-text>    </atomic-result-multi-value-text>
                      <atomic-result-multi-value-text field="sourcename"></atomic-result-multi-value-text>
                    </atomic-field-condition>

                    <atomic-field-condition style="display: flex;" class="field" if-defined="gmsaregion">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Region"></atomic-text> : </span>
                      <atomic-result-multi-value-text field="gmsaregion"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentproductname">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Product"></atomic-text> : </span>
                      <atomic-result-multi-value-text field="contentproductname"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="vvmctherapeuticareaveap">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Therapeutic Area (VEAP) "></atomic-text> : </span>
                      <atomic-result-multi-value-text field="vvmctherapeuticareaveap"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="vvmctherapeuticarea">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Therapeutic Area "></atomic-text> : </span>
                      <atomic-result-multi-value-text  #atomictext  field="vvmctherapeuticarea"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentintendeduse">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Intended Use "></atomic-text> : </span>
                      <atomic-result-multi-value-text field="contentintendeduse"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentlanguage">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Language "></atomic-text> : </span>
                      <atomic-result-multi-value-text field="contentlanguage"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentproactive">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Proactive "></atomic-text> : </span>
                      <atomic-result-multi-value-text field="contentproactive"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentdocumentowner">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Document Owner "></atomic-text> : </span>
                      <atomic-result-multi-value-text field="contentdocumentowner"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentspcategoryannouncements">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Announcements "></atomic-text> : </span>
                      <atomic-result-multi-value-text field="contentspcategoryannouncements"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentspcategoryfunctionalareas">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Functional Areas "></atomic-text> : </span>
                      <atomic-result-multi-value-text field="contentspcategoryfunctionalareas"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentspcategorygmacapabilities">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="GMA Capabilities "></atomic-text> : </span>
                      <atomic-result-multi-value-text field="contentspcategorygmacapabilities"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentspcategoryleadermessages">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Leader Messages "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="contentspcategoryleadermessages"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentspcategoryregions">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Regions "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="contentspcategoryregions"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentspcategoryspecialtopics">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Special Topics "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="contentspcategoryspecialtopics"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentspcategorytherapeuticareas">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Therapeutic Areas "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="contentspcategorytherapeuticareas"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contenttherapeuticarea">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Therapeutic Areas "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="contenttherapeuticarea"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentspauthor">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Author "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="contentspauthor"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition class="field" if-defined="gmsapublisheddate">
                      <span class="field">
                        <span class="field-label" style="font-weight: bold;">Published Date:</span>
                        <atomic-result-date field="gmsapublisheddate"
                          format="ddd MMM D YYYY"
                        ></atomic-result-date>
                      </span>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentversion">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Version "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="contentversion"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="qdimpacteddepartment">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Impacted Department "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="qdimpacteddepartment"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentitemstatus">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Status "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="contentitemstatus"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition class="field" if-defined="qdeffectivedate">
                      <span class="field">
                        <span class="field-label">Effective Date :</span>
                        <atomic-result-date field="qdeffectivedate"
                          format="ddd MMM D YYYY"
                        ></atomic-result-date>
                      </span>
                    </atomic-field-condition>
    
                    <atomic-field-condition class="field" if-defined="qdfinaldate">
                      <span class="field">
                        <span class="field-label">Final Date :</span>
                        <atomic-result-date field="qdfinaldate"
                          format="ddd MMM D YYYY"
                        ></atomic-result-date>
                      </span>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="gvdsection">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="GVD Section "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="gvdsection"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition class="field" if-defined="vvmcgvdeffectivedate">
                      <span class="field">
                        <span class="field-label">Effective Date :</span>
                        <atomic-result-date field="vvmcgvdeffectivedate"
                          format="ddd MMM D YYYY"
                        ></atomic-result-date>
                      </span>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="vvmcgvdindication">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Indication "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="vvmcgvdindication"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="vvmcgvdveapid">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="VEAP ID OR REV/OPS ID "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="vvmcgvdveapid"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="productgenerictradename">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Product Generic/Trade Name "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="productgenerictradename"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="vvmcgvdkeycontact">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Key Contact "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="vvmcgvdkeycontact"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="vvmcgvddepartment">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Department (VEAP) "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="vvmcgvddepartment"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="vvmc_core_model_type">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Model Type "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="vvmc_core_model_type"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition class="field" if-defined="vvmc_core_dcr_approval_date">
                      <span class="field">
                        <span class="field-label">DRC Approval Date :</span>
                        <atomic-result-date field="vvmc_core_dcr_approval_date"
                          format="ddd MMM D YYYY"
                        ></atomic-result-date>
                      </span>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="vvmc_core_activity_type">
                      <span class="field-label" style="font-weight: bold;"><atomic-text value="Activity Type "></atomic-text>:</span>
                      <atomic-result-multi-value-text field="vvmc_core_activity_type"></atomic-result-multi-value-text>
                    </atomic-field-condition>
                  </div>

                  <div>
                    
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentdocumenttype">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Document Type"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="contentdocumenttype"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentdocumentsubtype">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Document SubType"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="contentdocumentsubtype"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="qddocumenttype">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Document Type"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="qddocumenttype"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="qddocumentsubtype">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Document Subtype"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="qddocumentsubtype"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentproactive">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Proactive"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="contentproactive"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="gmsavvmcapprovaldate">
                      <span class="field">
                        <span class="field-label" style="font-weight: bold;">Approval Date :</span>
                        <atomic-result-date field="gmsavvmcapprovaldate"
                          format="ddd MMM D YYYY"
                        ></atomic-result-date>
                      </span>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="payerregion">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Payer Region"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="payerregion"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="mrlclassification">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="MRL Classification"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="mrlclassification"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentdocumentnumber">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Document Number"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="contentdocumentnumber"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentsourceid">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Document ID"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="contentsourceid"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="gmsacountry">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Country"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="gmsacountry"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentinclm">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Content In CRM"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="contentinclm"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="contentinirms">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Content In IRMS"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="contentinirms"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="qdsensitivityclassification">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Sensitivity Classification"></atomic-text> : </span
                      >
                      <atomic-result-multi-value-text field="qdsensitivityclassification"></atomic-result-multi-value-text>
                    </atomic-field-condition>
                   
                    <atomic-field-condition style="display: flex;" class="field" if-defined="impactedcountry">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Impacted Countries/Regions"></atomic-text>:</span
                      >
                      <atomic-result-multi-value-text field="impactedcountry"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="payer">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Payer"></atomic-text>:</span
                      >
                      <atomic-result-multi-value-text field="payer"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition style="display: flex;" class="field" if-defined="payertopic">
                      <span class="field-label" style="font-weight: bold;"
                        ><atomic-text value="Payer Topic"></atomic-text>:</span
                      >
                      <atomic-result-multi-value-text field="payertopic"></atomic-result-multi-value-text>
                    </atomic-field-condition>
    
                    <atomic-field-condition class="field" if-defined="gmsaapprovaldate">
                      <span class="field">
                        <span class="field-label" style="font-weight: bold;">Approval Date :</span>
                        <atomic-result-date field="gmsaapprovaldate"
                          format="ddd MMM D YYYY"
                        ></atomic-result-date>
                      </span>
                    </atomic-field-condition>
                  </div>

                  
                  
                </div>
                <style>
                  summary::-webkit-details-marker {
                    color: #00ACF3;
                    font-size: 125%;
                    margin-right: 2px;
                   }
                   summary:focus {
                     outline-style: none;
                   }
                   article > details > summary {
                     font-size: 28px;
                     margin-top: 16px;
                   }
                   details > p {
                     margin-left: 24px;
                   }
                   details details {
                     margin-left: 36px;
                   }
                   details details summary {
                     font-size: 16px;
                   }
                </style>
                <div>
                  <section>
                  <article>
                    <details>
                      <summary>More Details ...</summary>
                      <atomic-field-condition style="display: flex;" class="field" if-defined="contentdocumentowner">
                        <span class="field-label" style="font-weight: bold;"><atomic-text value="Document Owner "></atomic-text> : </span>
                        <atomic-result-multi-value-text field="contentdocumentowner"></atomic-result-multi-value-text>
                      </atomic-field-condition>
                    </details>
                  </article>
                </section>
              </div>
              </atomic-result-section-title-metadata>


              <atomic-result-section-excerpt>
                <atomic-result-text field="excerpt"></atomic-result-text>
              </atomic-result-section-excerpt>
              <atomic-result-section-bottom-metadata>
              </atomic-result-section-bottom-metadata>
            </template>
          </atomic-result-template>
        </atomic-result-list> -->



      </atomic-layout-section>

      <!-- <atomic-layout-section section="pagination">
        <atomic-load-more-results></atomic-load-more-results>
      </atomic-layout-section> -->
      <atomic-layout-section section="pagination">
        <div style="display: flex; justify-content: space-between; width: 100vw;">
          <div><atomic-pager></atomic-pager></div>
          <div><atomic-results-per-page [initialChoice]="resultsPerPageValue"></atomic-results-per-page></div>
        </div>
      </atomic-layout-section>
    </atomic-layout-section>
  </atomic-search-layout>

</div>

  <!-- <app-results-page-footer>
    
  </app-results-page-footer> -->
  <app-footer></app-footer>
</atomic-search-interface>